import api from '../services/api';

/**
 * "Saved" products — the one heart on cards, the product page and in the
 * header. Signed-in shoppers save to their account wishlist; guests save
 * in this browser, and those saves move into the account at sign-in.
 * Every heart for a product stays in step through a small subscription.
 */
const KEY = 'saved_products';
const listeners = new Set();

const read = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(ids) ? ids.filter((id) => Number.isInteger(id)) : [];
  } catch {
    return [];
  }
};
const write = (ids) => {
  try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* private mode */ }
};

export const guestSavedIds = () => read();

export const setGuestSaved = (productId, saved) => {
  const ids = read().filter((id) => id !== productId);
  write(saved ? [productId, ...ids].slice(0, 100) : ids);
  notify(productId, saved);
};

export const notify = (productId, saved) => listeners.forEach((fn) => fn(productId, saved));

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

/** Moves this browser's saves into the signed-in shopper's wishlist. */
export const mergeGuestSaves = async () => {
  const ids = read();
  if (ids.length === 0) return;
  await Promise.allSettled(ids.map((id) => api.post(`/api/customer/wishlist/${id}`)));
  write([]);
};
